import types from 'constants/actionTypes';
import { combineReducers } from 'redux';

const initialState = {
  byId: {},
};

const byId = (state, { type, payload = {} }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }
  const {
    functionalGroupId,
    designOption,
    filters,
    newSelectedOptions,
  } = payload ? payload : {};

  switch (type) {
    case types.ADD_DESIGN_OPTION_FILTER:
      return {
        ...state,
        [functionalGroupId]: {
          ...state[functionalGroupId],
          [designOption]: filters,
        },
      };
    case types.REMOVE_DESIGN_OPTION_FILTER:
      const currentState = state[functionalGroupId];
      currentState[designOption] = newSelectedOptions;
      if (!newSelectedOptions.length) delete currentState[designOption];
      return {
        ...state,
        [functionalGroupId]: {
          ...currentState,
        },
      };
    case types.CLEAR_DESIGN_OPTION_FILTERS:
      const oldState = state;
      delete oldState[functionalGroupId];
      return { ...oldState };
    case types.CLEAR_ALL_DESIGN_OPTION_FILTERS:
      return {};
    case types.CLEAR_ALL_LOCAL_FILTERS:
      return { closeAllFilterForms: true };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
